// extracted by mini-css-extract-plugin
export var box = "_58-1";
export var checkboxRow = "_58-8";
export var checked = "_58-2";
export var descriptionSpacer = "_58-a";
export var disabled = "_58-3";
export var icon = "_58-6";
export var input = "_58-0";
export var labelSpacer = "_58-9";
export var medium = "_58-5";
export var small = "_58-4";
export var text = "_58-7";